import axios from "@/api/config/request";
import { BASE_API } from "./index";

/**
 * 获取登录用户信息
 * @returns {Promise} Promise
 */
export function getInfo() {
  return axios.get(`${BASE_API}/account/info`);
  // return axios.get("/mock/account.json");
}
/**
 * 找回密码/个人修改登录密码（手机号）
 * @param {Object} data
 * @returns {Promise} Promise
 */
export function retrievePassword(data) {
  return axios.post(`${BASE_API}/account/password/retrieve`, data);
}

/**
 * 换绑手机号
 * @param {Object} data
 * @returns {Promise} Promise
 */
export function changePhone(data) {
  return axios.put(`${BASE_API}/account/mobile/change`, data);
}